import { memo, useCallback } from 'react';

import { useTrackAssetModalCommentPanelOpen } from '@air/analytics';
import { MessageSquareIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useAssetModalRightPanel } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';

export const AssetModalContentHeaderCommentsPanelButton = memo(() => {
  const { isRightPanelOpen, showRightPanelTab } = useAssetModalRightPanel();
  const { trackAssetModalCommentPanelOpen } = useTrackAssetModalCommentPanelOpen();

  const handleShowCommentsPanel = useCallback(() => {
    showRightPanelTab('comments');
    trackAssetModalCommentPanelOpen();
  }, [showRightPanelTab, trackAssetModalCommentPanelOpen]);

  if (isRightPanelOpen) {
    return null;
  }

  return (
    <IconButton
      adsIcon
      icon={MessageSquareIcon}
      label="Show Comments Panel"
      appearance="ghost"
      color="gray"
      size="medium"
      onClick={handleShowCommentsPanel}
    />
  );
});

AssetModalContentHeaderCommentsPanelButton.displayName = 'AssetModalContentHeaderCommentsPanelButton';
